
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Carousel from '@/ui-kit/components/carousel';
import {
  CarouselPaginationType,
  CarouselProperty,
  CarouselPropsEventType,
} from '@/ui-kit/components/carousel/enums';
import { CarouselItemActionType } from './carousel-item/enums';
import ContainerOverviewCarouselItem from './carousel-item';

export default {
  name: 'ContainerOverviewHeroCarousel',
  components: {
    Carousel,
    ContainerOverviewCarouselItem,
  },
  props: {
    carouselItems: {
      default: () => ([]),
      type: Array,
    },
    carouselTrackEvent: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      activeIndex: 0,
      StylePositionType,
      StyleSizeType,
      StyleColorSchemeType,
      CarouselPaginationType,
      CarouselProperty,
      CarouselPropsEventType,
      CarouselItemActionType,
    };
  },
  computed: {
    primaryButtonTrackEvent() {
      return `${this.carouselTrackEvent}_Slide ${this.activeIndex + 1} primary button click`;
    },
    secondaryButtonTrackEvent() {
      return `${this.carouselTrackEvent}_Slide ${this.activeIndex + 1} secondary button click`;
    },
  },
  methods: {
    handleActiveIndexChange(index) {
      this.activeIndex = index;
    },
  },
};
